import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: ['DV_DP_CL_other_formats_title'] as const,
}
